import { ColumnDef } from "@tanstack/react-table";
import { formatMoneyCents } from "@/core/utils/money";
import { IPayout } from "@/payouts/payouts";

export const AmountCol = (): ColumnDef<IPayout> => ({
  header: "Amount",
  accessorFn: (row) => row.amount,
  cell: ({ row }) => formatMoneyCents(row.original.amount) ?? "$0",
});
